import { Flex, Box, useColorModeValue, Link } from "@chakra-ui/react";

export default function Footer(): JSX.Element {
  return (
    <Flex
      h="60px"
      justifyContent={{ base: "center", lg: "space-between" }}
      bg={useColorModeValue("gray.1000", "gray.900")}
      alignItems="center"
      pr="6"
    >
      <Box display={{ base: "none", lg: "flex" }} gap={6} fontSize="sm">
        <Link href="#" isExternal>
          Privacy Policy{" "}
        </Link>
        <Link href="#" isExternal>
          Terms and Conditions
        </Link>
        {/* <Link href="#" isExternal>License</Link> */}
      </Box>
      <Box fontSize={{ base: "xs", md: "sm" }}>
        © 2024{" "}
        <Link href="https://www.sequelstring.com/" isExternal>
          Sequelstring AI Pvt. Ltd.
        </Link>
      </Box>
    </Flex>
  );
}
